import { uuid } from './uuid'

export const SESSION_IDLE_MS = 30 * 60 * 1000
const KEY = 'arena_pa_session'

type Stored = { id: string; lastSeen: number }

let memory: Stored | null = null

function read(): Stored | null {
  try {
    const raw = window.sessionStorage.getItem(KEY)
    if (raw) {
      const parsed = JSON.parse(raw) as Stored
      if (
        typeof parsed.id === 'string' &&
        typeof parsed.lastSeen === 'number'
      ) {
        return parsed
      }
    }
  } catch {
    // storage unavailable: fall back to memory
  }
  return memory
}

function write(s: Stored): void {
  memory = s
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify(s))
  } catch {
    // memory copy is enough
  }
}

export function getSessionId(now: number = Date.now()): string {
  const current = read()
  const next =
    !current || now - current.lastSeen > SESSION_IDLE_MS
      ? { id: uuid(), lastSeen: now }
      : { id: current.id, lastSeen: now }
  write(next)
  return next.id
}

export function resetSession(): void {
  memory = null
  try {
    window.sessionStorage.removeItem(KEY)
  } catch {
    // nothing to clear
  }
}
